import { amountDisplay } from '@gameday/common/formats'
import ChevronRight from '@material-ui/icons/ChevronRight'
import styled from 'styled-components'

import CustomButton from '../Button'

const Wrapper = styled.div`
  flex-shrink: 0;
  display: inline-flex;
  flex-direction: column;
  justify-content: space-between;
  width: ${props => (props.view ? '100%' : '332px')};
  padding: 2em 1.5em 1.5em;
  background: var(--white);
  border: 1px solid var(--border-color);
  color: var(--dark-text);
  @media only screen and (max-width: 540px) {
    padding: 1em;
  }
`

const Title = styled.h4`
  margin: 0 0 16px;
  font-weight: 500;
  font-size: 18px;
  color: var(--dark-text);
  @media only screen and (max-width: 540px) {
    font-size: 16px;
    margin-bottom: 10px;
  }
`

const Description = styled.p`
  display: block;
  display: -webkit-box;
  margin: 0;
  color: var(--sub-text);
  font-size: 12px;
  line-height: 16px;
  height: calc(12px * 16px * 3);
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  @media only screen and (max-width: 540px) {
    height: calc(12px * 16px * 2);
    -webkit-line-clamp: 2;
  }
`

const Footer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 0.5em;
  .product-button {
    padding: 0;
    min-width: 32px;
  }
`

const Price = styled.span`
  font-size: 24px;
  font-weight: 700;
  @media only screen and (max-width: 540px) {
    font-size: 18px;
  }
`

const Card = ({ background, color, description, freeText, href, price, title, view, target, currencyCode }) => (
  <Wrapper view={view}>
    <div>
      <Title>{title}</Title>
      <Description>{description}</Description>
    </div>
    <Footer>
      <Price>{price === 0 ? freeText : amountDisplay(price.toFixed(2), currencyCode)}</Price>
      {href && (
        <CustomButton
          background={background}
          color={color}
          href={href}
          hasIcon
          className="product-button"
          target={target}
        >
          <ChevronRight />
        </CustomButton>
      )}
    </Footer>
  </Wrapper>
)

Card.defaultProps = {
  background: '#A53B32',
  color: '#FFFFFF',
  freeText: 'FREE',
}

export default Card
